var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Circle, Path } from "react-native-svg";
function SvgIconVioletNotFound(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 45,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Circle, {
    fill: "#5B41F0",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M16.172 26.463c3.497-2.38 6.98-2.9 10.452-1.558M15.7 14.529l-2.595 2.594m2.593 0l-2.594-2.594M30.7 14.529l-2.595 2.594m2.593 0l-2.594-2.594",
    stroke: "#FFF",
    strokeLinecap: "round"
  }))));
}
export default SvgIconVioletNotFound;